import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Toast} from 'primereact/toast';
import {MultiSelect} from 'primereact/multiselect';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID} from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

const AccountTypes = [
    {label : 'Asset', value : 'Asset'},
    {label : 'Liability', value : 'Liability'},
    {label : 'Equity', value : 'Equity'},
    {label : 'Revenue', value : 'Revenue'},
    {label : 'Expense', value : 'Expense'},
];

class AccountsMaster extends Component {
    state = {
        roles : [],
        type: 'add',
        Id:null,
        UserId:null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        approvalroles: [], 
        approvalRoleId: null,       
        UserId1: '',              
        FirstName : '',
        MiddleName : '',
        LastName : '',
        EmailId: '',
        Password : '',
        MobileNumber : '',
        Activedirectory : false,
        Adloginid : '',
        Disablelogin : false,
        IsActive : false,
        createdBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate : new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch : false,
        AccountType : null
    }

    componentDidMount(){
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GeUsers?id='+id);   
        this.props.getMasterKeywordList('Role'); 
        this.props.getMasterKeywordList('Employee');
        this.props.getMasterKeywordList('ApprovalRole'); 
        let type = this.props.match.params.type;

        axios.get('/master/api/DropDownValues/FRole')
                .then(response =>{
                    if(response.status === 200){
                        let data = []
                        if(response.data && response.data.length > 0){
                            data = response.data.map(list => {
                                let value= list.id;
                                let id = list.id;
                                let text = list.text
                                return {label : text, value:value.toString(), id:id};
                            })
                        }
                        this.setState({functionalRoleOptions: data})
                    }}
                )
                .catch(err => {
                    this.growl.show({severity: 'error', summary: null, detail: 'Functional Roles Api Failed'});
                })   

        if(type !== 'add'){
            this.timer();
        }
    }

    timer = () =>{
        this.intervalID = setInterval(()=> {
            this.fetchSingleProcess();
        },2000)
    }    
    componentWillUnmount(){
        if(this.props.tableLists.usersList!==undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () =>{

        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];
        if(this.props.tableLists.usersList!==undefined) {
            storageItems = this.props.tableLists.users;
            clearInterval(this.intervalID);
        }
        if(storageItems){
            let filterData = storageItems;
            if(filterData){
                let roles ='';
                let functionalRoles ='';
                let approvalroles ='';
                if(filterData.roleAssigned!=null){
                    roles = filterData.roleAssigned.split(",") 
                }
                if(filterData.functionalRole!=null){
                    functionalRoles = filterData.functionalRole.split(",") 
                }
                if(filterData.approvalrole!=null){
                    approvalroles = filterData.approvalrole.split(",") 
                }
                var data = {
                    type:type,
                    Id:filterData.id,
                    UserId: filterData.userId,
                    EmployeeId: filterData.employeeId,            
                    RoleId: roles,
                    approvalRoleId:approvalroles,
                    UserId1: filterData.userid1,
                    FirstName: filterData.firstName,
                    functionalRoleId: functionalRoles,
                    MiddleName: filterData.middleName,
                    LastName:filterData.lastName,
                    EmailId: filterData.emailId,
                    Password: filterData.password,
                    MobileNumber: filterData.mobileNumber,
                    Activedirectory: filterData.activedirectory,
                    Adloginid: filterData.adloginid,
                    Disablelogin: filterData.disablelogin,
                    IsActive: filterData.isActive,
                    CreatedBy : filterData.createdby,
                    CreatedDate : filterData.createddate,
                }
                this.setState(data);
                
            }
        }

    }


    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    add = () => {

        if(this.state.EmployeeId === null){
            this.growl.show({severity: 'error', summary: null, detail: 'Employee is required'});
            return;
        }else if(this.state.RoleId === null || this.state.RoleId === ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Role is required'});
            return;
        }
        
        else if(this.state.UserId1 === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'UserName is required'});
            return;
        }else if(this.state.FirstName === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'FirstName is required'});
            return;
        }else if(this.state.LastName === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'LastName is required'});
            return;
        }else if(this.state.EmailId === "" || this.state.EmailId === null){
            this.growl.show({severity: 'error', summary: null, detail: 'EmailId is required'});
            return;
        }else if(this.state.Password === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'Password is required'});
            return;
        }else if(this.state.MobileNumber === "" || this.state.MobileNumber === null ){
            this.growl.show({severity: 'error', summary: null, detail: 'MobileNumber is required'});
            return;
        }else if(this.state.approvalRoleId === "" || this.state.approvalRoleId === null ){
        this.growl.show({severity: 'error', summary: null, detail: 'Approval Roleid is required'});
        return;
        }else if(this.state.functionalRoleId === "" || this.state.functionalRoleId === null ){
            this.growl.show({severity: 'error', summary: null, detail: 'functional Roleid is required'});
            return;
        }
        var data = {
            EmployeeId: this.state.EmployeeId,            
            RoleId: null,
            UserId1: this.state.UserId1,
            FirstName: this.state.FirstName,
            FunctionalRole: this.state.functionalRoleId.join(),
            Approvalrole: this.state.approvalRoleId.join(),
            MiddleName: this.state.MiddleName,
            LastName: this.state.LastName,
            EmailId: this.state.EmailId,
            Password: this.state.Password,
            MobileNumber: this.state.MobileNumber,
            RoleAssigned: this.state.RoleId.join(),
            Activedirectory: this.state.Activedirectory,
            Adloginid: this.state.Adloginid,
            Disablelogin: this.state.Disablelogin,
            IsActive: this.state.IsActive,
            CompanyId : this.state.CompanyId,
            CreatedBy : this.state.createdBy,
            CreatedDate : this.state.createdDate,
        }
   
        
        if(this.state.type === 'edit'){
            data.UserId = this.state.UserId;
            data.Id = this.state.Id
        }

        this.props.processDynamicData('user',this.state.type,data,'GeUsers');

    }

    resetData = () => {
        var data = {
            UserId: null,
            EmployeeId: null,            
            RoleId: null,
            functionalRoleId: null,
            approvalRoleId: null,
            AccountId:'',
            FirstName: '',
            MiddleName: '',
            LastName:'',
            EmailId: '',
            Password: '',
            MobileNumber: '',
            Activedirectory: false,
            Disablelogin: false,
            IsActive: false,
            type:'add'
        }
        this.setState(data);
    }
  
    render() {   
        if(this.props.success){
            REDIRECT_TO_URL('/users/',this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        
        let roleOptions = [];
        if(this.props.Role && this.props.Role.length > 0 ){
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if(this.props.ApprovalRole && this.props.ApprovalRole.length > 0 ){
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/users/';
        if(this.props.userDetail && this.props.match.params.id!==undefined){
            if(this.props.userDetail.userId === this.props.match.params.id){
                redirectURL = "/dashboard";
            }
        }
        

        return (
            <div className="p-grid">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>{this.state.type} Account</h1>
     
                        <div className="p-grid mt1">
                           
                            <div className="p-col-6 p-offset-3">


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Account Id <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="AccountId" placeholder="Account Id" value={this.state.AccountId} onChange={this.change}/>
                                </div>	


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Account Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="AccountName" placeholder="Account Name" value={this.state.AccountName} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Account Description </label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="p-col-12" name="AccountDescription" placeholder="Account Description" value={this.state.AccountDescription} onChange={this.change}/>
                                </div>	

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Account Type <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                <Dropdown className="p-col-12" placeholder="Select Account Type" options={AccountTypes} value={this.state.AccountType} name="AccountType" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div>	  

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                <InputSwitch checked={this.state.IsActive} onChange={this.change} name="IsActive" value={this.state.IsActive} />
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-12">

                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                            
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        Role : (state.keyword.Role!==undefined) ? state.keyword.Role : [],
        ApprovalRole : (state.keyword.ApprovalRole!==undefined) ? state.keyword.ApprovalRole : [],        
        tableLists : state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists : (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(AccountsMaster);